// component
import React from "react";
import Home from "../../pages/client/home/home.tsx";
import AdminLogin from "../../pages/admin/login/login.tsx";

export const routes: any = {
    pages: [
        {
            label: 'ورود ادمین',
            address: '/admin/login',
            component: <AdminLogin />,
            icon: '',
            show: false,
        },
        {
            label: 'خانه',
            address: '/',
            component: <Home />,
            icon: '',
            show: false,
        },
    ],
    client: [
        {
            label: 'ثبت نام مشاور املاک',
            address: '#agent',
            component: '',
            icon: '',
        },
        {
            label: 'ثبت نام  عکاسان',
            address: '#photograph',
            component: '',
            icon: '',
        },
    ],
    api: [
        {
            name: 'api',
            address: 'https://dash.madvandmelk.com/api/v1',
            group: 'api'
        },
    ]
}
